import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  HomeIcon,
  InboxIcon,
  HeartIcon as HeartOutline,
  CogIcon,
  ArrowLeftOnRectangleIcon,
  Bars3Icon,
  XMarkIcon,
  MagnifyingGlassIcon,
  UserCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  UserGroupIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { useWindowSize } from "react-use";
import { useTranslation } from "react-i18next";

import "bootstrap/dist/css/bootstrap.min.css";
import { Globe } from "lucide-react";
import { Carousel } from "react-bootstrap";
import logoes from "../assets/Logo.png";

import languageLogo from "../assets/Icons/language-icon-matrimony.png";
import NavPointsIcon from "../assets/Icons/points-icon.svg";
import NavDropdownIcon from "../assets/Icons/arrow-down.svg";

import AsideHomeIconWhite from "../assets/Icons/home-icon-white.svg";
import AsideHomeIconDark from "../assets/Icons/home-icon-dark.svg";
import AsideProfileIconWhite from "../assets/Icons/profile-icon-white.svg";
import AsideProfileIconDark from "../assets/Icons/profile-icon-dark.svg";
import AsideMatchingProfileIconWhite from "../assets/Icons/matching-profile-icon-white.svg";
import AsideMatchingProfileIconDark from "../assets/Icons/matching-profile-icon-dark.svg";
import AsidePointsIconWhite from "../assets/Icons/points-icon-aside-white.svg";
import AsidePointsIconDark from "../assets/Icons/points-icon-aside-dark.svg";
import AsideSettingsIconWhite from "../assets/Icons/settings-icon-white.svg";
import AsideSettingsIconDark from "../assets/Icons/settings-icon-dark.svg";
import AsideLogoutIconWhite from "../assets/Icons/logout-icon-white.svg";
import AsideLogoutIconDark from "../assets/Icons/logout-icon-dark.svg";
import RightArrowCard from "../assets/Icons/right-arrow.svg";
import { FiSettings } from "react-icons/fi";

import FavouritesIconFilledWhite from "../assets/Icons/favourite-icon-outline.png";
import FavouritesIconFilledRed from "../assets/Icons/favourite-icon-filled.svg";

import AsideFavouriteIconOutlineDark from "../assets/Icons/aside-favourite-icon-dark.svg";
import AsideFavouriteIconOutlineWhite from "../assets/Icons/aside-favourite-icon-white.svg";

import NavBar from "./navbar";
import Footer from "./footer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MatchingProfiles = () => {
  const { t, i18n } = useTranslation();
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [profiles, setProfiles] = useState([]);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [openCardIndex, setOpenCardIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const dropdownRefLanguage = useRef(null);
  const dropdownRefProfile = useRef(null);
   const isMobile = window.innerWidth < 640;
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [isRechargePointsFormOpen, setIsRechargePointsFormOpen] =
    useState(false);
  const [locationPreference, setLocationPreference] = useState([]);
  const [previewDocument, setPreviewDocument] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [openSections, setOpenSections] = useState({
    personal: true,
    family: true,
    horoscope: true,
    preferences: true,
    documents: true,
  });
  const [isFavourited, setIsFavourited] = useState({});
  const [points, setPoints] = useState();
  const [isHeartsAnimating, setIsHeartsAnimating] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const { width, height } = useWindowSize();
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const [ageFilter, setAgeFilter] = useState("");
  const [casteFilter, setCasteFilter] = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [sort, setSortProfile] = useState("");
  const [profileToView, setProfileToView] = useState(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportReason, setReportReason] = useState("");
  const [viewedProfiles, setViewedProfiles] = useState([]);
     const [ShowPopupRechargePoints, setShowPopupRechargePoints] = useState(false);


  const fetchLocationPreferredProfiles = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `https://backend.newbrindha.com/matrimony/location-preference`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        return;
      }

      if (!response.ok) {
        throw new Error(t("fetchLocationPreferencesError"));
      }

      const data = await response.json();
      // Ensure data is an array
      setLocationPreference(data.profiles || []);
    } catch (error) {
      console.log(error.message);
      toast.error(t("fetchLocationPreferencesError"));
    }
  };

  const toggleFavourite = async (profile) => {
    try {
      const token = localStorage.getItem("authToken");
      const profileId = profile.matrimony_id;
      const isCurrentlyFavorited = favorites.includes(profileId);
      let updatedFavorites;

      if (isCurrentlyFavorited) {
        updatedFavorites = favorites.filter((id) => id !== profileId);
      } else {
        updatedFavorites = [...favorites, profileId];
      }

      setFavorites(updatedFavorites);

      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/favorite-profiles",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            favorite_profile_ids: updatedFavorites.filter(Boolean),
          }),
        },
      );

      if (!response.ok) {
        throw new Error(t("favoriteUpdateError"));
      }

      const data = await response.json();
      console.log("Favorites updated:", data);
    } catch (error) {
      console.error("Error updating favorites:", error);
      setFavorites(favorites);
      toast.error(t("favoriteUpdateError"));
    }
  };

  const toggleMobileView = (index) => {
    if (isMobile) {
      setOpenCardIndex(openCardIndex === index ? null : index);
    }
  };

  const fetchPoints = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `https://backend.newbrindha.com/wallet/balance`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        return;
      }

      if (!response.ok) {
        throw new Error(t("fetchPointsError"));
      }

      const data = await response.json();
      setPoints(data.points_balance);
    } catch (error) {
      console.log(error.message);
      toast.error(t("fetchPointsError"));
    }
  };

  const NoProfilesFound = () => {
    const { t } = useTranslation();
    return (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-600">{t("noProfilesFound")}</p>
        </div>
    );
  };

   useEffect(() => {
      const fetchViewedProfiles = async () => {
        try {
          const token = localStorage.getItem('authToken');
          const response = await fetch('https://backend.newbrindha.com/matrimony/viewed-profiles', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
          
          if (response.ok) {
            const data = await response.json();
            setViewedProfiles(data.viewed_profiles || []);
          }
        } catch (error) {
          console.error('Error fetching viewed profiles:', error);
        }
      };
      
      fetchViewedProfiles();
    }, []);
    
    
    const handleSpendPoints = (profile) => {
      if (viewedProfiles.includes(profile.matrimony_id)) {
        
        setSelectedProfile(profile);
        return;
      }
      
      
      setProfileToView(profile);
      setShowConfirmPopup(true);
    };
    
    
    const confirmSpendPoints = async () => {
      const token = localStorage.getItem('authToken');
      try {
        
        const response = await fetch('https://backend.newbrindha.com/wallet/spend', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            spend_requests: [{ profile_matrimony_id: profileToView.matrimony_id, points: 500 }],
          }),
        });
    
        const data = await response.json();
        if (response.ok) {
          if (data.token) localStorage.setItem('authToken', data.token);
          
          
          const markViewedResponse = await fetch('https://backend.newbrindha.com/matrimony/mark-viewed', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ profile_matrimony_ids: [profileToView.matrimony_id] }),
          });
          
          if (markViewedResponse.ok) {
            setViewedProfiles(prev => [...prev, profileToView.matrimony_id]);
            setSelectedProfile(profileToView);
            
           
            const balanceResponse = await fetch('https://backend.newbrindha.com/wallet/balance', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            
            if (balanceResponse.ok) {
              const balanceData = await balanceResponse.json();
              window.dispatchEvent(new CustomEvent('updatePoints', { detail: balanceData.points_balance }));
            }
            
            toast.success(t('pointsSpentSuccess'));
          }
        } else {
          setShowPopupRechargePoints(true);
        }
      } catch (error) {
        console.error('Spend Points Error:', error.message);
        toast.error(t('pointsSpentError', { error: error.message }));
      } finally {
        setShowConfirmPopup(false);
        setProfileToView(null);
      }
    };

  const fetchProfiles = async () => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/login");
      return;
    }

    const response = await fetch(
      `https://backend.newbrindha.com/matrimony/preference`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (response.status === 401) {
      localStorage.removeItem("authToken");
      navigate("/");
      return;
    }

    if (!response.ok) {
      throw new Error(t("fetchProfilesError"));
    }

    const data = await response.json();
    
   
    if (data.message && data.matching_profiles) {
      // Show toast message if no compatible profiles but showing Utthamam matches
      // if (data.message.includes("Utthamam")) {
      //   toast.info(data.message);
      // }
      
      setProfiles(data.profiles?.length > 0 ? data.profiles : data.matching_profiles || []);
    } else {
      // Fallback to old structure
      setProfiles(Array.isArray(data.profiles) ? data.profiles : []);
    }
  } catch (error) {
    setError(error.message);
    toast.error(t("fetchProfilesError"));
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchPoints();
    fetchProfiles();
    fetchLocationPreferredProfiles();

    const savedFavorites = localStorage.getItem("favorites");
    if (savedFavorites) {
      setFavorites(JSON.parse(savedFavorites));
    }
  }, []);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobile && openCardIndex !== null) {
        const cards = document.querySelectorAll('.profile-card');
        let clickedOutside = true;
        
        cards.forEach(card => {
          if (card.contains(event.target)) {
            clickedOutside = false;
          }
        });
        
        if (clickedOutside) {
          setOpenCardIndex(null);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile, openCardIndex]);

  const photos = selectedProfile?.photos_base64
    ? Object.entries(selectedProfile.photos_base64).map(([key, value]) => ({
        id: key,
        base64: value,
      }))
    : [];

  const toggleLanguageDropdown = () => {
    setShowLanguageDropdown((prev) => !prev);
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setShowLanguageDropdown(false);
  };

  const toggleProfileDropdown = () => {
    setShowProfileDropdown((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutsideLanguage = (event) => {
      if (
        dropdownRefLanguage.current &&
        !dropdownRefLanguage.current.contains(event.target)
      ) {
        setShowLanguageDropdown(false);
      }
    };

    const handleClickOutsideProfile = (event) => {
      if (
        dropdownRefProfile.current &&
        !dropdownRefProfile.current.contains(event.target)
      ) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideLanguage);
    document.addEventListener("mousedown", handleClickOutsideProfile);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideLanguage);
      document.removeEventListener("mousedown", handleClickOutsideProfile);
    };
  }, []);

  const Section = ({ title, isOpen, toggle, children }) => (
    <div className="mb-2">
      <div
        className="flex justify-between items-center cursor-pointer p-2 bg-gray-100 hover:bg-gray-50 transition-colors duration-200 border-l-4 border-[#FF6D31D9] mb-4"
        onClick={toggle}
      >
        <h3 className="font-medium text-[#676666] text-[16px] mb-1">{title}</h3>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <ChevronDownIcon className="h-5 w-5" />
        </motion.div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="mt-2 space-y-3">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );

  const DetailItem = ({ label, value }) => (
    <p className="text-sm text-[#676666] ml-2">
      <span className="font-medium">{label}:</span> {value || t("notSpecified")}
    </p>
  );

  const handlePreviewDocument = (documentBase64) => {
    setPreviewDocument(documentBase64);
  };

  const closePreview = () => {
    setPreviewDocument(null);
  };

  const handleSearch = useCallback(
    debounce((value) => {
      setSearchTerm(value);
    }, 300),
    [],
  );

  const filteredProfiles = profiles.filter((profile) => {
    const matchesSearch =
      profile.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ??
      true;
    const matchesAge = ageFilter
      ? profile.age
          ?.toString()
          .toLowerCase()
          .startsWith(ageFilter.toLowerCase())
      : true;
    const matchesCaste = casteFilter
      ? profile.caste?.toLowerCase().startsWith(casteFilter.toLowerCase())
      : true;
    const matchesLocation = locationFilter
      ? profile.native?.toLowerCase().startsWith(locationFilter.toLowerCase())
      : true;
    return matchesSearch && matchesAge && matchesCaste && matchesLocation;
  });

  const sortedFilteredProfiles = useMemo(() => {
    const sorted = [...filteredProfiles];
    if (sort === "A-Z") {
      sorted.sort((a, b) =>
        (a.full_name?.toLowerCase() || "").localeCompare(
          b.full_name?.toLowerCase() || "",
        ),
      );
    } else if (sort === "Z-A") {
      sorted.sort((a, b) =>
        (b.full_name?.toLowerCase() || "").localeCompare(
          a.full_name?.toLowerCase() || "",
        ),
      );
    }
    return sorted;
  }, [filteredProfiles, sort]);

  const cardVariants = {
    hover: { scale: 1.05, transition: { duration: 0.2 } },
    tap: { scale: 0.95 },
  };

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const ProfileCardImageShadow = {
    boxShadow: "rgba(5, 5, 5, 0.95) 0px -50px 36px -28px inset",
  };

  return (
    <div className=" flex flex-col bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient px-0 flex-col">
      <div className="min-h-[100dvh] flex-row w-full">
        <NavBar />

        <section className="sticky top-10 z-40 pt-10 px-4 pb-4 w-full">
          <article className="flex flex-col sm:flex-row gap-2">
            <div className="relative sm:w-52 md:w-full text-white py-2">
              <input
                type="text"
                placeholder={t("searchPlaceholder")}
                defaultValue={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
                className="w-full pl-10 py-2 pr-6 sm:w-52 sm:pl-10 sm:pr-4 md:w-[350px] rounded-lg focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 bg-white text-[#676666] border-2 border-gray-300 placeholder:text-[#676666] focus:outline-none focus:w-72"
              />
              <MagnifyingGlassIcon className="h-5 w-5 text-[#676666] absolute left-3 top-1/2 transform -translate-y-1/2" />
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 sm:gap-2 md:gap-4 w-fit">
                <input
                  type="text"
                  placeholder={t("ageFilter")}
                  value={ageFilter}
                  onChange={(e) => setAgeFilter(e.target.value)}
                  className="w-full lg:w-32 px-2 py-2 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200"
                />
                <input
                  type="text"
                  placeholder={t("casteFilter")}
                  value={casteFilter}
                  onChange={(e) => setCasteFilter(e.target.value)}
                  className="w-full lg:w-32 px-2 py-2 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200"
                />
                <input
                  type="text"
                  placeholder={t("locationFilter")}
                  value={locationFilter}
                  onChange={(e) => setLocationFilter(e.target.value)}
                  className="w-full lg:w-32 px-2 py-2 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200"
                />
              </div>
              <div className="">
                <select
                  value={sort}
                  onChange={(e) => setSortProfile(e.target.value)}
                  className="w-auto sm:w-[100px] px-2 py-2 rounded-lg border-2 border-gray-300 focus:ring-2 text-[#676666]"
                >
                  <option value="">{t("sortBy")}</option>
                  <option value="A-Z">{t("sortAZ")}</option>
                  <option value="Z-A">{t("sortZA")}</option>
                </select>
              </div>
            </div>
          </article>
        </section>

        <main className="z-30 bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient p-4 md:p-6 min-h-screen">
         <div className="p-4 md:p-6 bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient px-0 flex-col0">
          <p className="text-xl font-bold mb-4 text-[#676666]">
            🌀 {t("preferenceByRashi")}
          </p>
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <p className="text-gray-600">{t("loadingProfiles")}</p>
            </div>
          ) : error ? (
            <div className="flex justify-center items-center h-64">
              <p className="text-red-500">{error}</p>
            </div>
          ) : sortedFilteredProfiles.length > 0 ? (
            <>
              {/* Add this subheading for nakshatra-matched profiles */}
              {profiles.some(p => p.nakshatra_match_type) && (
                <span className="text-lg font-semibold mb-2 text-[#676666] flex items-center gap-2">
                  <FiSettings className="text-[#676666]" />
                  {t("systemMatchedByNakshatra")}
                </span>
              )}
              <div className="relative">
                <button
                  onClick={scrollLeft}
                  className="lg:hidden absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-lg z-40"
                >
                  <ChevronLeftIcon className="h-6 w-6 text-gray-700" />
                </button>
                <div
                  ref={scrollContainerRef}
                  className="flex gap-4 overflow-x-auto scroll-smooth px-2 sm:px-4"
                  style={{ scrollBehavior: "smooth" }}
                >
                  {sortedFilteredProfiles.map((profile, index) => {
                    const photo = profile.photo
                      ? profile.photo
                      : "https://images.unsplash.com/photo-1541823709867-1b206113eafd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTMxfHxnaXJsfGVufDB8fDB8fHww";
                      const verificationStatus = profile.verification_status || "pending";
                      const verificationColor = verificationStatus === "approve" ? "bg-green-500" : "bg-red-500";
                      const verificationText = verificationStatus === "approve" ? t("approved") : t("pending");
                    return (
                      <motion.div
                      key={index}
                      className="profile-card relative rounded-2xl cursor-pointer min-w-[200px] sm:w-[280px] md:w-[220px] min-h-[220px] overflow-hidden group max-h-full z-30"
                      whileHover="hover"
                      whileTap="tap"
                      onClick={() => toggleMobileView(index)}
                    >
                      {/* Verification badge */}
                      <div className={`absolute top-2 right-2 z-30 ${verificationColor} text-white text-[10px] xs:text-xs px-1.5 py-0.5 xs:px-2 xs:py-1 rounded-full font-medium shadow-lg`}>
                        {verificationText}
                      </div>

                      {viewedProfiles.includes(profile.matrimony_id) && (
                            <div
                              className={`absolute z-30 bg-blue-500 text-white text-[10px] xs:text-xs 
                                px-1.5 py-0.5 xs:px-2 xs:py-1 rounded-full font-medium shadow-lg
                                ${window.innerWidth < 640 ? 'left-2 top-8' : 'left-2 top-2'}
                              `}
                            >
                              {t("viewed")}
                            </div>
                          )}

             {profile.nakshatra_match_type && (
              <div
                className={`absolute z-30 ${
                  profile.nakshatra_match_type === 'Utthamam' ? 'bg-green-800' : 'bg-blue-500'
                } text-white text-[10px] xs:text-xs px-1.5 py-0.5 xs:px-2 xs:py-1 rounded-full font-medium shadow-lg left-2 top-56`}
              >
                
                {t("compatible")}
              </div>
            )}


                      
                      {/* Mobile favorite button */}
                      {/* <div
                        className="absolute top-3 right-3 z-20 lg:hidden"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavourite(profile);
                        }}
                      >
                        {favorites.includes(profile.matrimony_id) ? (
                          <HeartSolid className="h-6 w-6 text-red-500 border border-black rounded-full p-0.5 bg-white" />
                        ) : (
                          <HeartOutline className="h-6 w-6 text-white border border-black rounded-full p-0.5 bg-white" />
                        )}
                      </div> */}

                      <div 
                        className="absolute top-2 right-2 z-20 sm:hidden"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavourite(profile);
                        }}
                      >
                        {favorites.includes(profile.matrimony_id) ? (
                          <HeartSolid className="h-5 w-5 text-red-500" />
                        ) : (
                          <HeartOutline className="h-5 w-5 text-white" />
                        )}
                      </div>

                      {/* Hover/click details - updated to use openCardIndex */}
                      {(openCardIndex === index || !isMobile) && (
                        <motion.div
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.4, ease: "easeInOut" }}
                          className={`${isMobile ? 'flex' : 'hidden group-hover:flex'} absolute inset-0 bg-black/70 z-50 flex-col items-start justify-start text-white p-3 sm:p-4 md:p-5 h-full w-full overflow-y-auto`}
                        >
                          {/* Desktop favorite button */}
                          <div
                            className="hidden sm:block absolute top-3 right-3 cursor-pointer z-10"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleFavourite(profile);
                            }}
                          >
                            {favorites.includes(profile.matrimony_id) ? (
                              <HeartSolid className="h-6 w-6 text-red-500" />
                            ) : (
                              <HeartOutline className="h-6 w-6 text-white" />
                            )}
                          </div>
                          
                          <p className="text-left text-base sm:text-lg md:text-xl font-bold mb-2">
                            {profile.full_name}
                          </p>
                          <div className="flex flex-col items-start justify-start space-y-1 text-sm w-full break-words">
                            <p className="text-sm sm:text-[15px] m-0 mt-1">
                              {t("age")}: {profile.age}
                            </p>
                            <p className="text-sm sm:text-[15px] m-0 mt-1">
                              {t("location")}: {profile.work_location}
                            </p>
                            <p className="text-sm sm:text-[15px] m-0 mt-1">
                              {t("occupation")}: {profile.occupation}
                            </p>
                            <button className="flex items-center gap-2 mt-2 text-white font-medium">
                              <img
                                src={NavPointsIcon}
                                alt="points-icon"
                                className="w-5 h-5"
                              />
                              {"500"}
                            </button>
                          </div>
                          <button
                              onClick={() => handleSpendPoints(profile)}
                              className="bg-[#fa6938] hover:bg-[#ff7142] active:bg-[#fa6938] mt-2 sm:mt-3 px-2 py-1 sm:px-3 sm:py-2 rounded-lg w-full text-xs sm:text-sm font-medium"
                            >
                              {viewedProfiles.includes(profile.matrimony_id) ? t("viewDetails") : t("moreDetails")}
                            </button>
                        </motion.div>
                      )}

                      {/* Image shadow and content */}
                      <div
                        className="absolute w-full h-full z-10"
                        style={ProfileCardImageShadow}
                      />
                      <img
                        src={photo}
                        alt={profile.full_name}
                        className="w-full h-full object-cover z-40 transition-all duration-300 ease-in-out group-hover:scale-105"
                      />
                      <div className="absolute m-2 bottom-0 left-0 right-0 bg-white/50 px-3 py-2 rounded-2xl text-black flex items-center justify-between z-40">
                        <div>
                          <h3 className="font-bold text-[16px] leading-tight">
                            {profile.full_name}
                          </h3>
                          <p className="text-sm mb-1 text-semibold">
                            {t("age")}: {profile.age}
                          </p>
                        </div>
                        <div className="text-white">
                          <img
                            src={RightArrowCard}
                            alt="RightArrowCard"
                            className="h-6 w-8"
                          />
                        </div>
                      </div>
                    </motion.div>
                    );
                  })}
                </div>
                <button
                  onClick={scrollRight}
                  className="lg:hidden absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-lg z-40"
                >
                  <ChevronRightIcon className="h-6 w-6 text-gray-700" />
                </button>
              </div>
               </>
                ) : (
                  <NoProfilesFound />
                )}
              </div>

          <div className="p-4 md:p-6 bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient px-0 flex-col">
            <p className="text-xl font-bold mb-4 text-[#676666]">
              📍 {t("preferenceByLocation")}
            </p>
            {loading ? (
              <div className="flex justify-center items-center h-64">
                <p className="text-gray-600">{t("loadingProfiles")}</p>
              </div>
            ) : error ? (
              <div className="flex justify-center items-center h-64">
                <p className="text-red-500">{error}</p>
              </div>
            ) : locationPreference.length > 0 ? (
              <div className="relative">
                <button
                  onClick={scrollLeft}
                  className="lg:hidden absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-lg z-40"
                >
                  <ChevronLeftIcon className="h-6 w-6 text-gray-700" />
                </button>
                <div
                  ref={scrollContainerRef}
                  className="flex gap-4 overflow-x-auto scroll-smooth px-2 sm:px-4"
                  style={{ scrollBehavior: "smooth" }}
                >
                  {locationPreference.map((profile, index) => {
                    const photo = profile.photo
                      ? profile.photo
                      : "https://images.unsplash.com/photo-1541823709867-1b206113eafd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTMxfHxnaXJsfGVufDB8fDB8fHww";
                    const verificationStatus = profile.verification_status || "pending";
                      const verificationColor = verificationStatus === "approve" ? "bg-green-500" : "bg-red-500";
                      const verificationText = verificationStatus === "approve" ? t("approved") : t("pending");
                    return (
                      <motion.div
                        key={index}
                        className="profile-card relative rounded-2xl cursor-pointer min-w-[200px] sm:w-[280px] md:w-[220px] min-h-[220px] overflow-hidden group max-h-full z-30"
                        whileHover="hover"
                        whileTap="tap"
                      >
                      <div className={`absolute top-2 right-2 z-30 ${verificationColor} text-white text-[10px] xs:text-xs px-1.5 py-0.5 xs:px-2 xs:py-1 rounded-full font-medium shadow-lg`}>
                        {verificationText}
                      </div>

                      {viewedProfiles.includes(profile.matrimony_id) && (
                            <div
                              className={`absolute z-30 bg-blue-500 text-white text-[10px] xs:text-xs 
                                px-1.5 py-0.5 xs:px-2 xs:py-1 rounded-full font-medium shadow-lg
                                ${window.innerWidth < 640 ? 'left-2 top-8' : 'left-2 top-2'}
                              `}
                            >
                              {t("viewed")}
                            </div>
                          )}
                        <div
                          className="absolute top-3 right-3 z-20 lg:hidden"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleFavourite(profile);
                          }}
                        >
                          {favorites.includes(profile.matrimony_id) ? (
                            <HeartSolid className="h-6 w-6 text-red-500 border border-black rounded-full p-0.5 bg-white" />
                          ) : (
                            <HeartOutline className="h-6 w-6 text-white border border-black rounded-full p-0.5 bg-white" />
                          )}
                        </div>
                        <motion.div
                          initial={{ opacity: 0, y: 20 }}
                          whileHover={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.4, ease: "easeInOut" }}
                          className="hidden group-hover:flex sm:flex absolute inset-0 bg-black/70 z-50 flex-col items-start justify-start text-white p-3 sm:p-4 md:p-5 h-full w-full overflow-y-auto"
                        >
                          <div
                            className="hidden sm:block absolute top-3 right-3 cursor-pointer z-10"
                            onClick={() => toggleFavourite(profile)}
                          >
                            {favorites.includes(profile.matrimony_id) ? (
                              <HeartSolid className="h-6 w-6 text-red-500" />
                            ) : (
                              <HeartOutline className="h-6 w-6 text-white" />
                            )}
                          </div>
                          <p className="text-left text-base sm:text-lg md:text-xl font-bold mb-2">
                            {profile.full_name}
                          </p>
                          <div className="flex flex-col items-start justify-start space-y-1 text-sm w-full break-words">
                            <p className="text-sm sm:text-[15px] m-0 mt-1">
                              {t("age")}: {profile.age}
                            </p>
                            <p className="text-sm sm:text-[15px] m-0 mt-1">
                              {t("location")}: {profile.work_location}
                            </p>
                            <p className="text-sm sm:text-[15px] m-0 mt-1">
                              {t("occupation")}: {profile.occupation}
                            </p>
                            <button className="flex items-center gap-2 mt-2 text-white font-medium">
                              <img
                                src={NavPointsIcon}
                                alt="points-icon"
                                className="w-5 h-5"
                              />
                              {points || t("points")}
                            </button>
                          </div>
                          <button
                              onClick={() => handleSpendPoints(profile)}
                              className="bg-[#fa6938] hover:bg-[#ff7142] active:bg-[#fa6938] mt-2 sm:mt-3 px-2 py-1 sm:px-3 sm:py-2 rounded-lg w-full text-xs sm:text-sm font-medium"
                            >
                              {viewedProfiles.includes(profile.matrimony_id) ? t("viewDetails") : t("moreDetails")}
                            </button>
                        </motion.div>
                        <div
                          className="absolute w-full h-full z-10"
                          style={ProfileCardImageShadow}
                        />
                        <img
                          src={photo}
                          alt={profile.full_name}
                          className="w-full h-full object-cover z-40 transition-all duration-300 ease-in-out group-hover:scale-105"
                        />
                        <div className="absolute m-2 bottom-0 left-0 right-0 bg-white/50 px-3 py-2 rounded-2xl text-black flex items-center justify-between z-40">
                          <div>
                            <h3 className="font-bold text-[16px] leading-tight">
                              {profile.full_name}
                            </h3>
                            <p className="text-sm mb-1 text-semibold">
                              {t("age")}: {profile.age}
                            </p>
                          </div>
                          <div className="text-white">
                            <img
                              src={RightArrowCard}
                              alt="RightArrowCard"
                              className="h-6 w-8"
                            />
                          </div>
                        </div>
                      </motion.div>
                    );
                  })}
                </div>
                <button
                  onClick={scrollRight}
                  className="lg:hidden absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-lg z-40"
                >
                  <ChevronRightIcon className="h-6 w-6 text-gray-700" />
                </button>
              </div>
            ) : (
              <div className="flex justify-center items-center h-64">
                <p className="text-gray-600">{t("noProfilesFound")}</p>
              </div>
            )}
          </div>
        </main>
      </div>

      <AnimatePresence>
        {selectedProfile && (
          <div
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[999]"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
          >
            <div
              className="bg-white rounded-xl max-w-4xl w-full p-4 overflow-y-auto max-h-[90vh] shadow-2xl"
              initial={{ scale: 0.9, opacity: 0, rotateX: -15, rotateY: -15 }}
              animate={{ scale: 1, opacity: 1, rotateX: 0, rotateY: 0 }}
              exit={{ scale: 0.9, opacity: 0, rotateX: -15, rotateY: -15 }}
              transition={{ type: "spring", stiffness: 100, damping: 20 }}
            >
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-[18px] font-semibold text-[#676666]">
                  {t("profileDetails")}
                </h2>
                <button
                  onClick={() => setSelectedProfile(null)}
                  className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                >
                  <XMarkIcon className="h-6 w-6 font-semibold text-red-500" />
                </button>
              </div>
              <div
                className="absolute top-4 right-4 sm:hidden z-20"
                onClick={() => toggleFavourite(selectedProfile)}
              >
                {favorites.includes(selectedProfile.matrimony_id) ? (
                  <HeartSolid className="h-6 w-6 text-red-500" />
                ) : (
                  <HeartOutline className="h-6 w-6 text-gray-500" />
                )}
              </div>
              <div className="mb-6">
                <Carousel
                  interval={3000}
                  className="w-full h-96 rounded-lg overflow-hidden shadow-lg"
                  indicators={(selectedProfile.photos?.length || 0) > 0}
                  prevIcon={<ChevronLeftIcon className="h-8 w-8 text-black" />}
                  nextIcon={<ChevronRightIcon className="h-8 w-8 text-black" />}
                >
                  {selectedProfile.photo && (
                    <Carousel.Item>
                      <img
                        src={selectedProfile.photo}
                        alt="Profile"
                        className="w-full h-96 object-cover"
                        onError={(e) => {
                          e.target.src = "/default-placeholder.png";
                          console.error("Failed to load profile photo");
                        }}
                      />
                    </Carousel.Item>
                  )}
                  {selectedProfile.photos?.map((photo, index) => (
                    <Carousel.Item key={index}>
                      <img
                        src={photo}
                        alt={`Photo ${index + 1}`}
                        className="w-full h-96 object-cover"
                        onError={(e) => {
                          e.target.src = "/default-placeholder.png";
                          console.error(`Failed to load photo ${index + 1}`);
                        }}
                      />
                    </Carousel.Item>
                  ))}
                  {!selectedProfile.photo &&
                    !selectedProfile.photos?.length && (
                      <Carousel.Item>
                        <img
                          src="/default-placeholder.png"
                          alt="Placeholder"
                          className="w-full h-96 object-cover"
                        />
                      </Carousel.Item>
                    )}
                </Carousel>
              </div>
              <div className="space-y-4">
                <Section
                  title={t("personalDetails")}
                  isOpen={openSections.personal}
                  toggle={() => toggleSection("personal")}
                >
                  <DetailItem
                    label={t("name")}
                    value={selectedProfile.full_name}
                  />
                  <DetailItem
                    label={t("matrimonyId")}
                    value={selectedProfile.matrimony_id}
                  />
                  <DetailItem label={t("age")} value={selectedProfile.age} />
                  <DetailItem
                    label={t("gender")}
                    value={selectedProfile.gender}
                  />
                  <DetailItem
                    label={t("dateOfBirth")}
                    value={selectedProfile.date_of_birth}
                  />
                  <DetailItem
                    label={t("height")}
                    value={selectedProfile.height}
                  />
                  <DetailItem
                    label={t("weight")}
                    value={selectedProfile.weight}
                  />
                  <DetailItem
                    label={t("email")}
                    value={selectedProfile.email}
                  />
                  <DetailItem
                    label={t("phone")}
                    value={selectedProfile.phone_number}
                  />
                  <DetailItem
                    label={t("motherTongue")}
                    value={selectedProfile.mother_tongue}
                  />
                  <DetailItem
                    label={t("native")}
                    value={selectedProfile.native}
                  />
                  <DetailItem
                    label={t("religion")}
                    value={selectedProfile.religion}
                  />
                  <DetailItem
                    label={t("caste")}
                    value={selectedProfile.caste}
                  />
                  <DetailItem
                    label={t("subCaste")}
                    value={selectedProfile.sub_caste}
                  />
                  <DetailItem
                    label={t("bloodGroup")}
                    value={selectedProfile.blood_group}
                  />
                </Section>
                <Section
                  title={t("familyProfessionalDetails")}
                  isOpen={openSections.family}
                  toggle={() => toggleSection("family")}
                >
                  <DetailItem
                    label={t("fatherName")}
                    value={selectedProfile.father_name}
                  />
                  <DetailItem
                    label={t("motherName")}
                    value={selectedProfile.mother_name}
                  />
                  <DetailItem
                    label={t("fatherOccupation")}
                    value={selectedProfile.father_occupation}
                  />
                  <DetailItem
                    label={t("motherOccupation")}
                    value={selectedProfile.mother_occupation}
                  />
                  <DetailItem
                    label={t("siblingCount")}
                    value={selectedProfile.sibling_count}
                  />
                  <DetailItem
                    label={t("occupation")}
                    value={selectedProfile.occupation}
                  />
                  <DetailItem
                    label={t("annualIncome")}
                    value={selectedProfile.annual_income}
                  />
                  <DetailItem
                    label={t("education")}
                    value={selectedProfile.education}
                  />
                  <DetailItem
                    label={t("company")}
                    value={selectedProfile.company}
                  />
                  <DetailItem
                    label={t("workLocation")}
                    value={selectedProfile.work_location}
                  />
                  <DetailItem
                    label={t("workCountry")}
                    value={selectedProfile.work_country}
                  />
                </Section>
                <Section
                  title={t("horoscopeDetails")}
                  isOpen={openSections.horoscope}
                  toggle={() => toggleSection("horoscope")}
                >
                  <DetailItem
                    label={t("nakshatra")}
                    value={selectedProfile.nakshatra}
                  />
                  <DetailItem
                    label={t("rashi")}
                    value={selectedProfile.rashi}
                  />
                  <DetailItem
                    label={t("ascendent")}
                    value={selectedProfile.ascendent}
                  />
                  <DetailItem
                    label={t("birthTime")}
                    value={selectedProfile.birth_time}
                  />
                  <DetailItem
                    label={t("birthPlace")}
                    value={selectedProfile.birth_place}
                  />
                </Section>
                <Section
                  title={t("preferences")}
                  isOpen={openSections.preferences}
                  toggle={() => toggleSection("preferences")}
                >
                  <DetailItem
                    label={t("preferredAgeRange")}
                    value={
                      selectedProfile.preferred_age_min &&
                      selectedProfile.preferred_age_max
                        ? `${selectedProfile.preferred_age_min} - ${selectedProfile.preferred_age_max}`
                        : t("notSpecified")
                    }
                  />
                  <DetailItem
                    label={t("preferredHeightRange")}
                    value={
                      selectedProfile.preferred_height_min &&
                      selectedProfile.preferred_height_max
                        ? `${selectedProfile.preferred_height_min} - ${selectedProfile.preferred_height_max}`
                        : t("notSpecified")
                    }
                  />
                  <DetailItem
                    label={t("preferredReligion")}
                    value={selectedProfile.preferred_religion}
                  />
                  <DetailItem
                    label={t("preferredCaste")}
                    value={selectedProfile.preferred_caste}
                  />
                  <DetailItem
                    label={t("preferredSubCaste")}
                    value={selectedProfile.preferred_sub_caste}
                  />
                  <DetailItem
                    label={t("preferredStatus")}
                    value={selectedProfile.preferred_work_status}
                  />
                  <DetailItem
                    label={t("preferredLocation")}
                    value={selectedProfile.preferred_location}
                  />
                </Section>
                <Section
                  title={t("documents")}
                  isOpen={openSections.documents}
                  toggle={() => toggleSection("documents")}
                >
                  {selectedProfile.horoscope_documents?.length > 0 ? (
                    selectedProfile.horoscope_documents.map(
                      (documentUrl, index) => (
                        <div key={`horoscope-${index}`} className="mt-4 mb-2">
                          <button
                            onClick={() => window.open(documentUrl, "_blank")}
                            className="flex items-center text-blue-500 hover:text-blue-700 transition-colors duration-200"
                          >
                            <DocumentTextIcon className="h-5 w-5 mr-2" />
                            <span>
                              {t("viewHoroscopeDocument", { index: index + 1 })}
                            </span>
                          </button>
                        </div>
                      ),
                    )
                  ) : (
                    <p>{t("noHoroscopeDocuments")}</p>
                  )}
                </Section>
              </div>
            </div>
          </div>
        )}
      </AnimatePresence>
       <AnimatePresence>
            {showConfirmPopup && (
              <motion.div
                className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[999]"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                <motion.div
                  className="bg-white rounded-xl max-w-md w-full p-6 shadow-2xl relative overflow-hidden"
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.9, opacity: 0 }}
                  transition={{ type: "spring", stiffness: 100, damping: 20 }}
                >
                  <h3 className="text-lg font-semibold text-[#676666] mb-4">
                    {t("confirmPointsSpend")}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {t("spendPointsMessage", {
                      points: 100,
                      name: profileToView?.full_name,
                    })}
                  </p>
                  <div className="flex justify-end space-x-3">
                    <button
                      onClick={() => setShowConfirmPopup(false)}
                      className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50"
                    >
                      {t("noThanks")}
                    </button>
                    <button
                      onClick={confirmSpendPoints}
                      className="px-4 py-2 bg-[#fa6938] text-white rounded-md text-sm font-medium hover:bg-[#ff7142]"
                    >
                      {t("confirm")}
                    </button>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

           <AnimatePresence>
              {ShowPopupRechargePoints && (
                <div
                  className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[999]"
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
                >
                  <div
                    className="relative bg-white rounded-xl max-w-2xl w-full p-4 overflow-y-auto max-h-[90vh] shadow-2xl"
                    initial={{ scale: 0.9, opacity: 0, rotateX: -15, rotateY: -15 }}
                    animate={{ scale: 1, opacity: 1, rotateX: 0, rotateY: 0 }}
                    exit={{ scale: 0.9, opacity: 0, rotateX: -15, rotateY: -15 }}
                    transition={{ type: "spring", stiffness: 100, damping: 20 }}
                  >
                    <button
                      onClick={() => setShowPopupRechargePoints(false)}
                      className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                    >
                      <XMarkIcon className="absolute right-2 top-2 h-8 w-8 font-semibold text-red-500 hover:bg-gray-100 p-1 rounded-lg" />
                    </button>
                    <p>{t("insufficientPoints")}</p>
                    <div className="flex justify-end">
                      <button
                        onClick={() => navigate("/points")}
                        className="px-3 py-1.5 rounded-lg bg-[#fa6938] hover:bg-[#ff7142] active:bg-[#fa6938] mt-2 text-white font-medium"
                      >
                        {t("goToRecharge")}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </AnimatePresence>


      <AnimatePresence>
        {isContactFormOpen && (
          <motion.div
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={modalVariants}
          >
            <motion.div
              className="bg-white rounded-xl max-w-md w-full p-6"
              variants={modalVariants}
            >
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-xl font-semibold text-gray-900">
                  {t("contactUs")}
                </h2>
                <button
                  onClick={() => setIsContactFormOpen(false)}
                  className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                >
                  <XMarkIcon className="h-5 w-5" />
                </button>
              </div>
              <form onSubmit={(e) => e.preventDefault()} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t("name")}
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200"
                    placeholder={t("contact.placeholders.name")}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t("email")}
                  </label>
                  <input
                    type="email"
                    className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200"
                    placeholder={t("contact.placeholders.email")}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t("message")}
                  </label>
                  <textarea
                    rows="4"
                    className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200"
                    placeholder={t("contact.placeholders.description")}
                  />
                </div>
                <button
                  type="submit"
                  className="w-full px-4 py-2 bg-[#ff8350] text-white rounded-lg hover:from-[#FFD54F] hover:to-[#FFA500] transition-all duration-200 shadow-lg"
                >
                  {t("sendMessage")}
                </button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {ShowPopupRechargePoints && (
          <div
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[999]"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
          >
            <div
              className="relative bg-white rounded-xl max-w-2xl w-full p-4 overflow-y-auto max-h-[90vh] shadow-2xl"
              initial={{ scale: 0.9, opacity: 0, rotateX: -15, rotateY: -15 }}
              animate={{ scale: 1, opacity: 1, rotateX: 0, rotateY: 0 }}
              exit={{ scale: 0.9, opacity: 0, rotateX: -15, rotateY: -15 }}
              transition={{ type: "spring", stiffness: 100, damping: 20 }}
            >
              <button
                onClick={() => setShowPopupRechargePoints(false)}
                className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
              >
                <XMarkIcon className="absolute right-2 top-2 h-8 w-8 font-semibold text-red-500 hover:bg-gray-100 p-1 rounded-lg" />
              </button>
              <p>{t("insufficientPoints")}</p>
              <div className="flex justify-end">
                <button
                  onClick={() => navigate("/points")}
                  className="px-3 py-1.5 rounded-lg bg-[#fa6938] hover:bg-[#ff7142] active:bg-[#fa6938] mt-2 text-white font-medium"
                >
                  {t("goToRecharge")}
                </button>
              </div>
            </div>
          </div>
        )}
      </AnimatePresence>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Footer />
    </div>
  );
};

export default MatchingProfiles;
